export default function Content({children}){
    return (
        <section className="content xui-px-1-half xui-lg-px-3">
            {children}
        </section>
    );
}